/** @format */

import React from 'react';
import { Grid } from '@mui/material';
import { SelectV, ClientIdCombo, AutocompleteV, InputV2, HeaderSection } from 'components';
import { useFormContext } from 'react-hook-form';
import { Beneficiary, HeaderParameters, MoreSettings } from './components';

const Advanced = (props) => {
  const { classes } = props;
  const methods = useFormContext();
  const { scType, scAutoApprove } = methods.watch();

  return (
    <Grid container direction="row" alignItems="center" spacing={2} item xs={9}>
      <Grid item xs={4}>
        <InputV2
          fullWidth
          label="کد پاسخ موفق"
          errors={methods.formState.errors}
          name="scHttpStatusCode"
          register={methods.register}
          rules={['required', 'isNumeric']}
          control={methods.control}
        />
      </Grid>

      <Grid item xs={4}>
        <InputV2
          label="قسمتی از پاسخ موفق"
          fullWidth
          errors={methods.formState.errors}
          name="scHttpResponse"
          register={methods.register}
          // rules={['required']}
          control={methods.control}
        />
      </Grid>

      <Grid item xs={4}>
        <AutocompleteV
          control={methods.control}
          errors={methods.formState.errors}
          register={methods.register}
          name="contentType"
          label="Content Type"
          rules={['required']}
          list={[
            {
              value: 'application/x-www-form-urlencoded',
              label: 'application/x-www-form-urlencoded',
            },
            { value: 'application/json', label: 'application/json' },
            { value: 'application/xsl', label: 'application/xsl' },
            { value: 'application/xml', label: 'application/xml' },
          ]}
          defaultValue={{
            value: 'application/x-www-form-urlencoded',
            label: 'application/x-www-form-urlencoded',
          }}
        />
      </Grid>

      <Grid container item xs={12} spacing={2} direction="row" alignItems="center">
        <Grid item xs={4}>
          <SelectV
            label="نوع دسترسی"
            name="scAutoApprove"
            options={[
              { value: 'false', label: 'نیاز به دسترسی' },
              { value: 'true', label: 'دسترسی آزاد' },
            ]}
            control={methods.control}
            rules={['required']}
            className={classes.formControl}
            errors={methods.formState.errors}
            fullWidth
          />
        </Grid>

        <Grid item xs={4}>
          {scAutoApprove === 'true' && <ClientIdCombo methods={methods} setValueIndex="0" />}
        </Grid>
      </Grid>

      <Grid item xs={2}>
        <SelectV
          name="scType"
          label="نوع سرویس"
          options={[
            { value: 'REST', label: 'REST' },
            { value: 'SOAP', label: 'SOAP' },
          ]}
          control={methods.control}
          rules={['required']}
          className={classes.formControl}
          errors={methods.formState.errors}
          fullWidth
        />
      </Grid>

      {!scType ||
        (scType && scType === 'REST' && (
          <Grid item xs={6}>
            &nbsp;
          </Grid>
        ))}

      {scType && scType === 'SOAP' && (
        <>
          <Grid item xs={3}>
            <InputV2
              fullWidth
              errors={methods.formState.errors}
              name="scNamespace"
              label="Namespace"
              register={methods.register}
              rules={['required']}
              control={methods.control}
            />
          </Grid>

          <Grid item xs={3}>
            <InputV2
              fullWidth
              errors={methods.formState.errors}
              name="scMethodName"
              label="Method Name"
              register={methods.register}
              rules={['required']}
              control={methods.control}
            />
          </Grid>
        </>
      )}

      <Grid item xs={12}>
        <HeaderSection title="تعریف ذینفعان" />
      </Grid>

      <Grid item xs={12}>
        <Beneficiary />
      </Grid>

      <Grid item xs={12}>
        <HeaderSection title="پارامترهای Headers" />
      </Grid>

      <Grid item xs={12}>
        <HeaderParameters />
      </Grid>

      <Grid item xs={12}>
        <HeaderSection title="تنظیمات بیشتر" />
      </Grid>

      {/* <Grid item xs={12}> */}
      <MoreSettings />
      {/* </Grid> */}
    </Grid>
  );
};

export default Advanced;
